import { useEffect } from 'react';

export default function useDocumentTitle(title) {
  useEffect(() => {
    const baseTitle = document.title;
    document.title = `${title} - ${baseTitle}`;

    return () => {
      document.title = baseTitle;
    };
  }, [title]);
}
